export default "__VITE_ASSET__BzWE_c5$__"